// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"bridge-5"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M5 13V4L19 4.00084V13C19 13 16.5 10 12 10C7.5 10 5 13 5 13Z"}},{"tag":"g","attrs":{"id":"fill2"},"children":[{"tag":"path","attrs":{"fill":"props.fillColor2","d":"M1 20.0004V4H5V20.0004H1Z"}},{"tag":"path","attrs":{"fill":"props.fillColor2","d":"M23 20.0014V4.00098H19V20.0014H23Z"}}]},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M5 4H1V20.0004H5V4ZM5 4L19 4.00084M19 4.00084H23V20.0013H19V4.00084ZM5.5 12.4954C6.43804 11.6407 8.67212 10 12 10C15.3279 10 17.562 11.6407 18.5 12.4954","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const Bridge5Icon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'bridge-5',
    ref,
    icon: element,
  },
));

Bridge5Icon.displayName = 'Bridge5Icon';

export default Bridge5Icon;
